(function () {
  'use strict';

  function init() {
    const block = document.querySelector('[data-hk-block]');
    if (!block) return;

    const sectionId = block.dataset.sectionId;
    const form = document.getElementById('product-form-' + sectionId);
    if (!form) return;

    // ── Karakter-teller ──────────────────────────────────────────────
    const textarea = block.querySelector('.hk-textarea');
    const charCount = block.querySelector('.hk-char-count');

    if (textarea && charCount) {
      const max = parseInt(textarea.maxLength, 10) || 100;
      textarea.addEventListener('input', function () {
        charCount.textContent = textarea.value.length + ' / ' + max + ' tekens';
      });
    }
    if (textarea) textarea.disabled = true;

    // ── Naamkaart selectie (radio-stijl) ─────────────────────────────
    var selectedNaamkaart = null;
    var naamkaartCards = block.querySelectorAll('.kb-naamkaart-card');

    var priceSpan = block.querySelector('.kb-handschrift__price');
    var originalPriceText = priceSpan ? priceSpan.textContent : null;

    function showCardPrice(price) {
      if (!priceSpan) {
        var label = block.querySelector('.kb-handschrift__label');
        if (!label) return;
        priceSpan = document.createElement('span');
        priceSpan.className = 'kb-handschrift__price';
        label.appendChild(priceSpan);
      }
      priceSpan.textContent = ' (' + price + ')';
    }

    function restoreOriginalPrice() {
      if (originalPriceText !== null) {
        if (priceSpan) priceSpan.textContent = originalPriceText;
      } else {
        if (priceSpan) { priceSpan.remove(); priceSpan = null; }
      }
    }

    function positionAllTooltips() {
      naamkaartCards.forEach(function (card) {
        var tooltip = card.querySelector('.kb-naamkaart-tooltip');
        if (!tooltip) return;

        // Reset
        tooltip.style.left = '';
        tooltip.style.transform = '';
        tooltip.style.removeProperty('--tooltip-arrow-left');
        tooltip.style.removeProperty('--tooltip-arrow-transform');

        var cardRect = card.getBoundingClientRect();
        var tooltipWidth = tooltip.offsetWidth;
        var margin = 8;
        var vw = window.innerWidth;

        var defaultLeft = cardRect.left + cardRect.width / 2 - tooltipWidth / 2;
        var defaultRight = defaultLeft + tooltipWidth;
        var newLeftPx = null;

        if (defaultLeft < margin) {
          newLeftPx = margin - cardRect.left + tooltipWidth / 2;
        } else if (defaultRight > vw - margin) {
          newLeftPx = (vw - margin - tooltipWidth / 2) - cardRect.left;
        }

        if (newLeftPx !== null) {
          tooltip.style.left = newLeftPx + 'px';
          tooltip.style.transform = 'translateX(-50%)';
          var tooltipLeftInViewport = cardRect.left + newLeftPx - tooltipWidth / 2;
          var arrowLeft = (cardRect.left + cardRect.width / 2) - tooltipLeftInViewport;
          tooltip.style.setProperty('--tooltip-arrow-left', arrowLeft + 'px');
          tooltip.style.setProperty('--tooltip-arrow-transform', 'none');
        }
      });
    }

    positionAllTooltips();
    window.addEventListener('resize', positionAllTooltips);

    naamkaartCards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('kb-naamkaart-card--active')) {
          card.classList.remove('kb-naamkaart-card--active');
          selectedNaamkaart = null;
          restoreOriginalPrice();
          if (textarea) {
            textarea.disabled = true;
            textarea.value = '';
            if (charCount) charCount.textContent = '0 / ' + (parseInt(textarea.maxLength, 10) || 100) + ' tekens';
          }
        } else {
          naamkaartCards.forEach(function (c) {
            c.classList.remove('kb-naamkaart-card--active');
          });
          card.classList.add('kb-naamkaart-card--active');
          selectedNaamkaart = {
            variantId: card.dataset.variantId,
            productId: card.dataset.productId,
            name: card.dataset.name,
          };
          showCardPrice(card.dataset.price);
          if (textarea) {
            textarea.disabled = false;
            textarea.focus();
          }
        }
      });
    });

    // ── Form submit interceptie ───────────────────────────────────────
    // Luistert in de capture-fase zodat het vóór de product-form
    // custom element handler draait.
    form.addEventListener('submit', async function (e) {
      var berichtValue = textarea ? textarea.value.trim() : '';

      // Geen naamkaart — laat normale form submit door
      if (!selectedNaamkaart) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var kaartjeId = String(Date.now());

      // Variant ID — lees uit de SelectedVariant span die de variant picker bijhoudt
      var variantSpan = document.getElementById('SelectedVariant-' + sectionId);
      var variantId = variantSpan
        ? parseInt(variantSpan.dataset.variantId, 10)
        : null;

      // Fallback: lees direct uit het hidden input
      if (!variantId) {
        var variantInput = form.querySelector('input[name="id"]');
        variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      }

      if (!variantId) return;

      // Hoeveelheid
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      // Properties voor het hoofdproduct
      var mainProps = { '_kaartje_id': kaartjeId };
      if (berichtValue && selectedNaamkaart) mainProps['Bericht'] = berichtValue;
      if (selectedNaamkaart) mainProps['Naamkaartje'] = selectedNaamkaart.name;

      // Verzamel alle standaard properties[...] form velden (bijv. custom_option blocks)
      var formData = new FormData(form);
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value && !(match[1] in mainProps)) {
          mainProps[match[1]] = value;
        }
      });

      // Instructies: de textarea heeft form="product-form-<sectionId>" maar wordt
      // niet meegenomen bij een onderschepte submit — handmatig inlezen.
      var formId = 'product-form-' + sectionId;
      document.querySelectorAll('.pi-instructies__textarea[form="' + formId + '"]').forEach(function (ta) {
        var val = ta.value.trim();
        if (!val) return;
        var match = ta.dataset.propertyName && ta.dataset.propertyName.match(/^properties\[(.+)\]$/);
        if (match) mainProps[match[1]] = val;
      });

      var items = [{ id: variantId, quantity: qty, properties: mainProps }];

      // Voeg naamkaart toe als apart cart item
      if (selectedNaamkaart && selectedNaamkaart.variantId) {
        var naamkaartProps = { '_kaartje_id': kaartjeId, '_is_naamkaartje': '1' };
        if (berichtValue) naamkaartProps['Bericht'] = berichtValue;
        items.push({
          id: parseInt(selectedNaamkaart.variantId, 10),
          quantity: 1,
          properties: naamkaartProps,
        });
      }

      // Laadstatus op de knop
      var submitBtn = form.querySelector('[name="add"]');
      var btnLabel = submitBtn ? submitBtn.querySelector('.single-add-to-cart-button--text') : null;
      var originalLabel = btnLabel ? btnLabel.textContent : '';

      if (submitBtn) {
        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
      }

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            items: items,
            sections: 'cart-drawer,cart-bubble',
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) throw new Error('Cart add failed');
        var data = await response.json();

        // Ververs cart drawer HTML
        var sectionTargets = [
          { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
          { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
        ];

        if (data.sections) {
          sectionTargets.forEach(function (t) {
            var host = document.getElementById(t.id);
            if (!host || !data.sections[t.section]) return;
            var target = host.querySelector(t.selector) || host;
            var fresh = new DOMParser()
              .parseFromString(data.sections[t.section], 'text/html')
              .querySelector(t.selector);
            if (fresh) target.innerHTML = fresh.innerHTML;
          });
        }

        // Open cart drawer
        var cartDrawerEl = document.getElementById('Cart-Drawer');
        if (cartDrawerEl && typeof OverlayManager !== 'undefined') {
          OverlayManager.open(cartDrawerEl);
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        }

        // Zapiet re-init
        try {
          if (typeof window.initializeZapietApp === 'function') {
            window.initializeZapietApp();
          }
        } catch (zErr) {
          console.error('[hk] initializeZapietApp() threw', zErr);
        }

        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { items: data.items || [] },
        }));

        // Succes feedback
        if (btnLabel) btnLabel.textContent = 'Toegevoegd! ✓';
        setTimeout(function () {
          if (btnLabel) btnLabel.textContent = originalLabel;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
          }
        }, 2500);

      } catch (err) {
        console.error('[hk] Cart error:', err);
        if (btnLabel) btnLabel.textContent = 'Fout — probeer opnieuw';
        if (submitBtn) {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        }
        setTimeout(function () {
          if (btnLabel) btnLabel.textContent = originalLabel;
        }, 2500);
      }
    }, true); // capture: true — vóór product-form custom element handler
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
